import React, { useState } from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

import getName, { getNameLang } from "../../../../common/helpers/getName";
import { battleOfTheHunsId, christmasId } from "../../../../common/parameters";
import { IStateTree } from "../../../store/interfaces";
import { IUser } from "../../../store/user/models";
import Icon from "../../../icon";
import { host } from "../../../paths";
import Tooltip from "../../Tooltip";
import Dropdown from "../Dropdown";

import { StyledTopBar, StyledTitle, NotPlayable, ComposerImg, ComposerImgWrapper } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";
import { formatComposerName } from "../../../../common/helpers/formatComposerName";

const TopBar = ({
    plan,
    isBrowse,
    index,
    isPlay,
    isHomework,
    isHomeworkResult,
    deleteHomework,
    renameHomework,
    modifyHomeworkDate,
    modifyHomeworkDescription,
    isModeration,
}: IProps) => {
    const intl = useIntl();
    const user = useSelector((state: IStateTree) => state.user) as IUser;
    const [notPlayableTooltip, setNotPlayableTooltip] = useState(false);
    const isExtra = plan._id === battleOfTheHunsId || plan._id === christmasId;
    const name = (isHomework ? plan.name : getName(plan.name, intl)) as string;
    const lang = !isHomework ? getNameLang(plan.name, name) : intl.locale;
    return (
        <StyledTopBar>
            {!isBrowse && plan.meta?.opus?.composerImg && (
                <ComposerImgWrapper>
                    <Tooltip label={formatComposerName(plan.meta.opus.composerName || "", intl.locale)} marginTop={8} light>
                        <ComposerImg src={host + "composers/" + plan.meta.opus.composerImg}></ComposerImg>
                    </Tooltip>
                </ComposerImgWrapper>
            )}
            <StyledTitle>
                {!plan.playable && !isBrowse && !isHomework && !isModeration && (
                    <NotPlayable
                        onMouseEnter={() => setNotPlayableTooltip(true)}
                        onMouseLeave={() => setNotPlayableTooltip(false)}
                    >
                        <Icon i="alert" />
                        <div className={cn("Tooltip", notPlayableTooltip && "Show")}>
                            <FormattedMessage {...messages.notPlayable} />
                        </div>
                    </NotPlayable>
                )}
                <span title={name} lang={lang}>{name}</span>
            </StyledTitle>
            {((!isExtra && !isPlay && !isHomework) || (isHomework && isHomeworkResult)) && !isModeration && user.loggedIn && (
                <Dropdown
                    plan={plan}
                    isBrowse={isBrowse}
                    index={index}
                    isHomework={isHomework}
                    deleteHomework={deleteHomework}
                    renameHomework={renameHomework}
                    modifyHomeworkDate={modifyHomeworkDate}
                    modifyHomeworkDescription={modifyHomeworkDescription}
                />
            )}
        </StyledTopBar>
    );
};

export default TopBar;
